module.exports = __webpack_public_path__ + "static/media/Twopeopleatdesk.09b8505c.jpg";